import type { JSX } from 'react';

/**
 * Full-screen loading state shown while the database initializes.
 * This blocks the app until Dexie migrations complete.
 */
export function DatabaseLoadingState(): JSX.Element {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-3 bg-surface text-text-secondary">
      <div
        className="h-10 w-10 animate-spin rounded-full border-2 border-primary-600 border-t-transparent"
        aria-hidden
      />
      <p className="text-sm font-medium">Inizializzazione database...</p>
    </div>
  );
}
